import { IUploadedDocuments, IUploadingDocument } from 'us.collection.case/reducers/Dashboard/Interfaces'

export const UploadedDocuments: IUploadedDocuments = {
    data: [],
    isLoading: false,
    error: ""
}
export const UploadingDocument: IUploadingDocument = {
    data: "",
    isLoading: false,
    error: ""
}